import styled from 'styled-components';

import { IFrame } from '../../Common/IFrame';

export const CustomizationFrameWrapper = styled.div`
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  margin-bottom: 24px;
  border: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const CodeEditorFrame = styled.div`
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const StyledIframe = styled(IFrame)`
  width: 100%;
  height: 634px;
  display: block;
  box-sizing: border-box;
  border: none;
`;
